<template>
  
  <v-dialog  value="true"  persistent max-width="600px">
     <v-overlay :value="loading"></v-overlay>
      <v-card>
        <v-card-title>
          <span class="headline">Ajout Vadeur</span>
        </v-card-title>
        <v-card-text>
          <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
      >
    <v-text-field label="Nom"  v-model="nom" :rules="nomRules"/>
    <v-text-field label="Prénom" v-model="prenom" :rules="prenomRules"/>
    <v-text-field label="Téléphone (Login)" v-model="tel" :rules="telRules"/>
    <v-text-field label="UUID" v-model="uuid" :rules="uuidRules"/>
    <v-text-field label="Code Vendeur" v-model="codevendeur" :rules="codevendeurRules"/>
    <v-card-actions>
      <v-btn @click="$emit('closeDialogAddVad')">Annuler</v-btn>
     <v-spacer></v-spacer>
     <v-btn @click="addVadeur" color="primary" :disabled="!valid"
      :loading="loading"
      class="white--text"
     >Valider</v-btn>
   </v-card-actions>
     </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import {UserService} from '../../providers/UserService.js';

const userService = new UserService();
export default {
 
  data () {
    return {     
      loading:false,
      valid: true,
      nom: '',
      nomRules: [
      v => !!v || 'Nom oblogatoire',
      ],
      prenom: '',
      prenomRules: [
      v => !!v || 'Prénom oblogatoire',
      ],
      tel:'',
      telRules: [
      v => !!v || 'Téléphone  oblogatoire',
      v => (v && v.length == 10) || 'Numero à 10 chiffres',
      
      ],
      uuid:'',
      uuidRules: [
      v => !!v || 'UUID oblogatoire',
      ],
      codevendeur:'',
      codevendeurRules: [
      v => !!v || 'Code vendeur oblogatoire',
      ],
      
    lazy: false,
    }
  },
  computed: {
    /*actions () {
      return {
        close: {
          flat: true,
          text: 'Annuler',
        },
        save: {
          flat: true,
          text: 'Enregistrer',
          disabled:"!valid",
         handle: () => {
           this.addVadeur();
          }
        }
      }
    }*/
  },
  methods: {
    close:function(){

    },
    showMsgAwait: async function (title,type,msg){
         await this.$dialog.confirm({
                  text: msg,
                  type:type,
                  title: title,
                  actions: {
                    true: {
                      text: 'OK'
                    }
                  }
                })
    },
    addVadeur: function(){
        this.loading = true;
        userService.addVadeur(this.tel, this.nom, this.prenom, this.$globalService.getUser().site, this.codevendeur, this.uuid).then(res => { 
          this.loading = false;
          if(res){
            if (res.err !='error') {
              this.showMsgAwait(res.err_msg,'success',"Veuillez trouver ci-dessous les identifiants de <strong>"+this.nom+" "+this.prenom+"</strong> :<br><br>Login : <strong>"+this.tel+"</strong><br>Mot de passe : <strong>"+res.params.password+"</strong>");           
              this.$emit("reloadVadList")
                
              
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
          
      }
  }
}
</script>
